<app-loading-indicator-full *ngIf="showLoadingIndicator"></app-loading-indicator-full>
<app-register-form *ngIf="showForm" [registerInput]="registerInput"></app-register-form>
<div class="card" *ngIf="showFailMessage">
  <div class="card-body">
    <p>{{'message.invite-token-validation-fail'|translate}}</p>
  </div>
  <div class="card-footer">
    <button routerLink="/landing" class="btn btn-primary"><span class="mdi mdi-arrow-left-thick"></span></button>
  </div>
</div>
